import { FC, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useFormikContext } from 'formik';
import { render } from 'storyblok-rich-text-react-renderer';
import { RichText } from '../../types/cms_shared_types';

dayjs.extend(duration);

export interface DayCountInputs {
  formikParams?: {
    key: string;
  };
  startDate: string;
  endDate: string;
  daysPerYear: string;
  textTemplate: RichText;
}

export const dayCount = (startDate: string, endDate: string, daysPerYear: string) => {
  const days = Math.abs(Math.round(dayjs.duration(dayjs(endDate).diff(dayjs(startDate))).asDays()));

  const daysRatio = Number(daysPerYear) / 365;
  const daysPerPeriod = Math.ceil(days * daysRatio);

  return daysPerPeriod;
};

export const DayCount: FC<DayCountInputs> = ({ formikParams, startDate, endDate, daysPerYear, textTemplate }) => {
  const { setFieldValue } = useFormikContext();
  const [days, setDays] = useState(dayCount(startDate, endDate, daysPerYear));
  const paramsKey = useMemo(() => formikParams?.key, [formikParams?.key]);

  useEffect(() => {
    const _days = dayCount(startDate, endDate, daysPerYear);
    setDays(_days);
  }, [daysPerYear, endDate, startDate]);

  useEffect(() => {
    if (paramsKey) {
      setFieldValue(paramsKey, days.toString());
    }
  }, [days, paramsKey, setFieldValue]);

  return (
    <div className="text-xs">
      {render(textTemplate, {
        textResolver: (text) => text.replace('{x}', days.toString()),
      })}
    </div>
  );
};
